import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box } from '@mui/material';

// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Page404() {
  return (
    <>
      <Helmet>
        <title> 404 Page Not Found | Renewlabour </title>
      </Helmet>

      <Container sx={{ height: "100%" }}>
        <StyledContent sx={{ textAlign: 'center', alignItems: 'center' }}>
          <Typography variant="h3" paragraph>
            ขอโทษด้วยครับ ไม่มีหน้าเพจที่คุณต้องการ!
          </Typography>

          <Typography sx={{ color: 'text.secondary' }}>
            ขอโทษด้วย ไม่มีหน้าเพจที่คุณต้องการดังกล่าว! กรุณากลับหน้าแรก!
          </Typography>

          <Box
            component="img"
            src="/assets/404/illustration_404.svg"
            sx={{ height: 260, mx: 'auto', my: { xs: 5, sm: 10 } }}
          />

          <Button to="/homepage" size="large" variant="contained" component={RouterLink}>
            กลับไปหน้าแรก
          </Button>
        </StyledContent>
      </Container>
    </>
  );
}
